
import React, { useState, useEffect } from "react";
import Header from "../Componentes/Header";
import Menu from "../Componentes/Menu";
import Footer from "../Componentes/Footer";

export default function AdmisionesMatriculas() {
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");

  const [preescolar, setPreescolar] = useState(false);
  const [primaria, setPrimaria] = useState(false);
  const [bachillerato, setBachillerato] = useState(false);

  const [isMobile, setIsMobile] = useState(false);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleEnviarClick = async (e) => {
    e.preventDefault();

    if (enviando) return;

    // Validar campos obligatorios
    if (!nombre.trim() || !telefono.trim() || !email.trim()) {
      alert("Por favor, completa tu nombre, teléfono y correo.");
      return;
    }

    // Validar formato del correo
    const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

    if (!emailValido) {
      alert("Por favor, introduce un correo electrónico válido.");
      return;
    }

    // Validar selección del nivel educativo
    if (!preescolar && !primaria && !bachillerato) {
      alert("Selecciona al menos un nivel educativo.");
      return;
    }

    // Preparar datos para PHP
    const formData = new FormData();

    formData.append("nombre", nombre.trim());
    formData.append("telefono", telefono.trim());
    formData.append("email", email.trim());

    formData.append("preescolar", preescolar ? "true" : "false");
    formData.append("primaria", primaria ? "true" : "false");
    formData.append("bachillerato", bachillerato ? "true" : "false");

    setEnviando(true);

    try {
      const response = await fetch(
        "https://britanniaschool.co.com/correo.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const mensaje = await response.text();

      if (!response.ok) {
        throw new Error(
          `Error HTTP ${response.status}: ${mensaje}`
        );
      }

      alert(mensaje);

      // Limpiar los campos después de la respuesta exitosa
      setNombre("");
      setTelefono("");
      setEmail("");
      setPreescolar(false);
      setPrimaria(false);
      setBachillerato(false);
    } catch (error) {
      console.error("Error al enviar el formulario:", error);

      alert(
        "No se pudo enviar la solicitud. Verifica tu conexión e inténtalo nuevamente."
      );
    } finally {
      setEnviando(false);
    }
  };

  // Campos compartidos por las versiones móvil y escritorio
  const camposFormulario = (
    <>
      <h2>Contáctanos ahora</h2>

      <input
        type="text"
        name="nombre"
        placeholder="Nombre completo"
        autoComplete="name"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        required
      />

      <input
        type="tel"
        name="telefono"
        placeholder="Teléfono"
        autoComplete="tel"
        value={telefono}
        onChange={(e) => setTelefono(e.target.value)}
        required
      />

      <input
        type="email"
        name="email"
        placeholder="Correo electrónico"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <label>
        <input
          type="checkbox"
          name="preescolar"
          checked={preescolar}
          onChange={(e) => setPreescolar(e.target.checked)}
        />
        {" "}Preescolar
      </label>

      <label>
        <input
          type="checkbox"
          name="primaria"
          checked={primaria}
          onChange={(e) => setPrimaria(e.target.checked)}
        />
        {" "}Primaria
      </label>

      <label>
        <input
          type="checkbox"
          name="bachillerato"
          checked={bachillerato}
          onChange={(e) => setBachillerato(e.target.checked)}
        />
        {" "}Bachillerato
      </label>

      <button type="submit" disabled={enviando}>
        {enviando ? "Enviando..." : "Enviar"}
      </button>
    </>
  );

  return (
    <div>
      <Header />
      <Menu />

      {isMobile ? (
        <div className="admisionesMovil">
          <div className="imagenMatriculasResponsive">
            <img
              className="imgMatriculas"
              src="https://britanniaschool.co.com/imagenes/admision1.png"
              alt="Información de admisiones y matrículas"
            />
          </div>

          <form
            className="form-containerMatriculasResponsive"
            onSubmit={handleEnviarClick}
          >
            {camposFormulario}
          </form>

          <br />

          <a href="/" className="volver">
            Volver
          </a>

          <br />
          <br />
        </div>
      ) : (
        <div className="contenedorAdmisionesMatriculas">
          <div className="columnaAdmisionesMatriculas izquierdaAdmisionesMatriculas">
            <img
              className="imgMatriculas"
              src="https://britanniaschool.co.com/imagenes/admision1.png"
              alt="Información de admisiones y matrículas"
            />
          </div>

          <div className="columnaAdmisionesMatriculas derechaAdmisionesMatriculas">
            <form
              className="form-containerMatriculas"
              onSubmit={handleEnviarClick}
            >
              {camposFormulario}
            </form>
          </div>
        </div>
      )}

      <br />

      {!isMobile && (
        <a href="/" className="volver">
          Volver
        </a>
      )}

      <br />
      <br />

      <Footer />
    </div>
  );
}
